import { galleon, trade_ship, transport_ship, warship } from './creatures_naval.js';
import {
  bandit,
  dragon,
  goblin,
  ogre,
  orc,
  orcWolfRider,
  sorcerer,
  warlord,
} from './creatures_raiders.js';
import { humanoid } from './creatures_shared.js';
// Creature voxel prefabs — copied from adventure-craft.
// Voxel scale: 1 unit = 1/16 of a game unit (0.0625).
//
// Split by group; this file is the registry that assembles them (key order is
// part of the public `creaturePrefabs` shape):
//   creatures_undead.ts    skeletons, zombie, wraith, lich, death knight, banshee
//   creatures_raiders.ts   greenskins, bandits, sorcerer, dragon, wolf rider
//   creatures_naval.ts     the `ship()` rig + the four hulls
//   creatures_shared.ts    `box()` and `humanoid()` builders
import {
  banshee,
  deathKnight,
  lich,
  skeleton,
  skeletonArcher,
  wraith,
  zombie,
} from './creatures_undead.js';
import type { CharacterPrefab } from './types.js';

// ─── NPCs ────────────────────────────────────────────────────
const wizard: CharacterPrefab = {
  name: 'Wizard',
  maxHp: 40,
  parts: humanoid('#c4956a', '#2a2a6a', '#1a1a3a', '#2a2a6a', '#8888ff', 5, 6, 5),
};

export const creaturePrefabs: Record<string, CharacterPrefab> = {
  skeleton,
  zombie,
  wraith,
  lich,
  death_knight: deathKnight,
  orc,
  ogre,
  goblin,
  sorcerer,
  dragon,
  bandit,
  warlord,
  skeleton_archer: skeletonArcher,
  orc_wolf_rider: orcWolfRider,
  banshee,
  wizard,
  trade_ship,
  transport_ship,
  warship,
  galleon,
};
